module.exports = __webpack_public_path__ + "img/circle-outline.f8201545.svg";